<div class="relative w-full h-12 flex justify-between items-center">
  <div></div>
  <p class="text-3xl font-semibold text-gray-800 dark:text-white">My Embed</p>
  <div class="relative flex justify-center items-center">
    <button (click)="onClickCreateEmbed()" class="px-2 py-1 rounded bg-indigo-600">
      Embed Create
    </button>
  </div>
</div>
<div class="w-full h-0.5 rounded-full bg-indigo-600"></div>
<div class="relative w-full h-full">
  <mat-grid-list cols="5" rowHeight="1:1.3">
    @for (companyProject of companyProjectList; track companyProject) {
      <mat-grid-tile>
        <div class="relative w-full h-full p-2">
          <div
            class="relative w-full h-full flex flex-col rounded shadow bg-white dark:bg-gray-800"
          >
            <div class="relative w-full aspect-square flex-none">
              @if (companyProject.cover) {
                <img
                  class="relative w-full h-full object-cover"
                  [src]="companyProject.cover"
                  alt=""
                />
              } @else {
                <div
                  class="relative w-full h-full flex justify-center items-center bg-gray-200 dark:bg-gray-700"
                >
                  <p class="text-black dark:text-white font-semibold text-base lg:text-xl">
                    No Cover
                  </p>
                </div>
              }
            </div>
            <div
              class="relative w-full h-full flex flex-col justify-between p-2 bg-gray-100 dark:bg-gray-700"
            >
              <p class="text-black dark:text-white text-xl font-semibold">
                {{ companyProject.title }}
              </p>
              <div class="relative w-full flex flex-row gap-2">
                <button
                  class="px-4 py-1 text-sm text-white rounded bg-indigo-600"
                  (click)="onClickEditProject(companyProject)"
                >
                  editr
                </button>
                <button
                  class="px-4 py-1 text-sm text-white rounded bg-red-600"
                  (click)="onClickDeleteEmbed(companyProject)"
                >
                  delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-grid-tile>
    }
  </mat-grid-list>
</div>
